export const paths = {
  home: 'M3 11l9-8 9 8v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z',
  match: 'M4 20V10m6 10V5m6 15v-7m4 7H3',
  advisor: 'M12 3l1.8 4.6L18 9.4l-4.2 1.8L12 16l-1.8-4.8L6 9.4l4.2-1.8zM19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9z',
  schools: 'M3 21h18M5 21V9l7-5 7 5v12M9 21v-6h6v6',
  apply: 'M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6',
  forums: 'M4 5h16v11H9l-5 4z',
  track: 'M4 6h16M4 12h16M4 18h10',
  admin: 'M4 20V4h16v16zM9 9h6M9 13h6',
  account: 'M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0'
};

export const Icon = ({ name, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={paths[name] || paths.home} />
  </svg>
);

/** The Entrance monogram: a rounded square bearing a clean "E" mark. */
export const Mark = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 30 30" aria-hidden="true">
    <rect width="30" height="30" rx="9" style={{ fill: 'var(--g)' }} />
    <path
      d="M9.5 9.5v11M9.5 9.5h12M9.5 15h8.5M9.5 20.5h12"
      stroke="#fff"
      strokeWidth="3.2"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export const Wave = () => (
  <svg className="wave" viewBox="0 0 1200 60" preserveAspectRatio="none" aria-hidden="true">
    <path d="M0 34C200 8 380 56 600 30S1000 6 1200 32V60H0Z" fill="#fff" opacity=".18" />
    <path d="M0 44C220 22 420 62 640 40S1000 20 1200 44V60H0Z" style={{ fill: 'var(--bg)' }} />
  </svg>
);
